import type { ReactNode } from 'react';
import { Space, Tooltip, theme } from 'antd';
import { InfoCircleOutlined } from '@ant-design/icons';

interface HintLabelProps {
  /** The label itself — already translated, or a literal. */
  label: ReactNode;
  /** What the info icon explains on hover. */
  hint: ReactNode;
}

/** A column title or field label with an explanation one hover away. */
export const HintLabel = ({ label, hint }: HintLabelProps) => {
  const { token } = theme.useToken();

  return (
    <Space size={4}>
      {label}
      <Tooltip title={hint}>
        <InfoCircleOutlined style={{ color: token.colorTextTertiary }} />
      </Tooltip>
    </Space>
  );
};
